import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '@/config/oidc'
import store from '@/store/index'
import logger from '@/utils/logger'

// ── Rôles OIDC (configurés via variables d'environnement) ────────────
// VUE_APP_ROLE_NIVEAU0=AGUIRREORTIZ,HADDAD_SA,POIRIER_G,...
// VUE_APP_ROLE_ADMIN=PARE_ST,MERCURE_J,...
const ROLE_NIVEAU0 = process.env.VUE_APP_ROLE_NIVEAU0
  ? process.env.VUE_APP_ROLE_NIVEAU0.split(',').map(s => s.trim().toUpperCase())
  : []
const ROLE_ADMIN = process.env.VUE_APP_ROLE_ADMIN
  ? process.env.VUE_APP_ROLE_ADMIN.split(',').map(s => s.trim().toUpperCase())
  : []

function buildRoles (sub) {
  const roles = []
  const upperSub = sub.toUpperCase()
  if (ROLE_ADMIN.some(x => x === upperSub)) roles.push('admin')
  if (ROLE_NIVEAU0.some(x => x === upperSub)) roles.push('niveau0')
  roles.push('user')
  return roles
}

function showWelcomeNotification (givenName) {
  if (localStorage.getItem('welcomeMessage')) return
  localStorage.setItem('welcomeMessage', 'connected')

  const language = localStorage.getItem('APP_LANG_KEY')
  let message = `Bonjour ${givenName}, vous êtes maintenant connecté(e).`
  if (language === 'en') message = `Hello ${givenName}, You are now connected.`
  else if (language === 'es') message = `Buenos dias ${givenName}, ahora estas conectado`

  setTimeout(() => {
    store.commit('snackbar/showMessage', {
      message,
      color: 'success',
      icon: 'mdi-checkbox-marked-circle',
      timeout: 5000,
      position: { top: false, center: false, left: false, right: true },
    })
  }, 500)
}

function authenticateSilent () {
  store.dispatch('oidcStore/authenticateOidcSilent')
  document.removeEventListener('mousemove', authenticateSilent)
}

// ── Module OIDC ──────────────────────────────────────────────────────

const OIDC = vuexOidcCreateStoreModule(
  oidcSettings,
  { namespaced: true, dispatchEventsOnWindow: true },
  {
    userLoaded: (user) => {
      showWelcomeNotification(user.profile.given_name)

      store.commit('userInfo/updateUser', {
        name: user.profile.family_name,
        firstName: user.profile.given_name,
        mail: user.profile.email,
        displayName: `${user.profile.family_name}, ${user.profile.given_name}`,
        username: user.profile.email,
        roles: buildRoles(user.profile.sub),
        codeMs: user.profile.sub,
      })
    },
    userUnloaded: () => {
      localStorage.removeItem('welcomeMessage')
      store.commit('userInfo/resetUser')
    },
    accessTokenExpiring: () => {
      document.addEventListener('mousemove', authenticateSilent)
    },
    accessTokenExpired: () => {
      document.removeEventListener('mousemove', authenticateSilent)
      store.dispatch('oidcStore/signOutOidc')
    },
    silentRenewError: () => logger.info('OIDC user is unloaded'),
    userSignedOut: () => logger.info('OIDC user is signed out'),
  },
)

export default OIDC
